import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  MotionLines,
  SkyBackdrop,
  SlopeSurface,
  WalkerFigure,
} from './shared';

export default function WalkingEasyIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.easy;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Rahat yürüyüş">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={42} endY={40} accent={accent} />
      <WalkerFigure cx={46} cy={30} posture="easy" primary={primaryColor} />
      <MotionLines x={34} y={34} count={2} />
    </IllustrationSvg>
  );
}
